import { mainSiteUrl } from '@/mocks/categories';

export default function Footer() {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="w-full bg-background-900 text-white">
      <div className="max-w-6xl mx-auto px-6 md:px-8 py-12 md:py-16">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-10 md:gap-8">
          <div>
            <h3 className="text-lg font-heading font-semibold mb-4 text-white">Basetao Spreadsheet Hub</h3>
            <p className="text-sm text-white/60 leading-relaxed max-w-xs">
              Your independent resource for Basetao Spreadsheet shopping guides, product discoveries, reviews, and expert tips. We help international shoppers make smarter buying decisions.
            </p>
          </div>

          <div>
            <h4 className="text-sm font-label font-semibold uppercase tracking-wider text-white/80 mb-4">Quick Links</h4>
            <nav className="flex flex-col gap-2.5">
              <a href="/" className="text-sm text-white/60 hover:text-white transition-colors duration-200 cursor-pointer">
                Home
              </a>
              <a href="/basetao-spreadsheet-guide" className="text-sm text-white/60 hover:text-white transition-colors duration-200 cursor-pointer">
                Basetao Spreadsheet Guide
              </a>
              <a href="/basetao-review" className="text-sm text-white/60 hover:text-white transition-colors duration-200 cursor-pointer">
                Basetao Review
              </a>
              <a href={mainSiteUrl} target="_blank" rel="noopener nofollow" className="text-sm text-white/60 hover:text-white transition-colors duration-200 cursor-pointer">
                Visit Main Store
              </a>
            </nav>
          </div>

          <div>
            <h4 className="text-sm font-label font-semibold uppercase tracking-wider text-white/80 mb-4">Shop Categories</h4>
            <nav className="flex flex-wrap gap-2">
              <a href="https://kaspreadsheet.com/category-911-Shoes.html" target="_blank" rel="noopener nofollow" className="text-xs px-3 py-1.5 rounded-full bg-white/10 text-white/60 hover:bg-white/20 hover:text-white transition-all duration-200 cursor-pointer whitespace-nowrap">
                Shoes
              </a>
              <a href="https://kaspreadsheet.com/search-912/name/Shoes.html" target="_blank" rel="noopener nofollow" className="text-xs px-3 py-1.5 rounded-full bg-white/10 text-white/60 hover:bg-white/20 hover:text-white transition-all duration-200 cursor-pointer whitespace-nowrap">
                Hoodies
              </a>
              <a href="https://kaspreadsheet.com/search-913/name/Shoes.html" target="_blank" rel="noopener nofollow" className="text-xs px-3 py-1.5 rounded-full bg-white/10 text-white/60 hover:bg-white/20 hover:text-white transition-all duration-200 cursor-pointer whitespace-nowrap">
                T-Shirts
              </a>
              <a href="https://kaspreadsheet.com/search-914/name/Shoes.html" target="_blank" rel="noopener nofollow" className="text-xs px-3 py-1.5 rounded-full bg-white/10 text-white/60 hover:bg-white/20 hover:text-white transition-all duration-200 cursor-pointer whitespace-nowrap">
                Jackets
              </a>
              <a href="https://kaspreadsheet.com/search-915/name/Shoes.html" target="_blank" rel="noopener nofollow" className="text-xs px-3 py-1.5 rounded-full bg-white/10 text-white/60 hover:bg-white/20 hover:text-white transition-all duration-200 cursor-pointer whitespace-nowrap">
                Pants
              </a>
              <a href="https://kaspreadsheet.com/search-920/name/Shoes.html" target="_blank" rel="noopener nofollow" className="text-xs px-3 py-1.5 rounded-full bg-white/10 text-white/60 hover:bg-white/20 hover:text-white transition-all duration-200 cursor-pointer whitespace-nowrap">
                Accessories
              </a>
              <a href="https://kaspreadsheet.com/search-921/name/Shoes.html" target="_blank" rel="noopener nofollow" className="text-xs px-3 py-1.5 rounded-full bg-white/10 text-white/60 hover:bg-white/20 hover:text-white transition-all duration-200 cursor-pointer whitespace-nowrap">
                Bags
              </a>
            </nav>
          </div>
        </div>

        <div className="mt-12 pt-8 border-t border-white/10 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-xs text-white/40">
            &copy; {currentYear} Basetao Spreadsheet Hub. All rights reserved. This is an independent resource website.
          </p>
          <div className="flex items-center gap-4">
            <a href={mainSiteUrl} target="_blank" rel="noopener nofollow" className="text-xs text-white/40 hover:text-white/70 transition-colors duration-200 cursor-pointer">
              Main Store
            </a>
            <a href="/basetao-spreadsheet-guide" className="text-xs text-white/40 hover:text-white/70 transition-colors duration-200 cursor-pointer">
              Guide
            </a>
            <a href="/basetao-review" className="text-xs text-white/40 hover:text-white/70 transition-colors duration-200 cursor-pointer">
              Review
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}